<div mat-dialog-title flex-between [flex-align]="'center'" class="mat-typography">
  <h2 title-large emphasized>Notifications</h2>
  <div [flex-align]="'center'" flex-gap="small">
    <button mat-button data-testid="notifications-dialog-mark-all-as-read-button" (click)="markAllAsRead()">
      Mark all as read
    </button>
    <button mat-icon-button data-testid="open-all-notifications-button" (click)="openNotifications()">
      <mat-icon>{{ openInNewIcon }}</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography" [flex-gap]="'small'" [flex-direction]="'column'">
  @for (notification of $notifications(); track notification.id; let i = $index) {
    <mat-card>
      <app-notification-details [notification]="notification" />
    </mat-card>
    @if (i === $notifications().length - 3) {
      <div #anchor></div>
    }
  }

  <div [flex-align]="'center'" [flex-direction]="'column'" [text-align]="'center'" body-large>
    <mat-icon [text-colour]="'secondary'">{{ flag2Icon }}</mat-icon>
    @if ($notifications().length) {
      That's all your unread notifications.
    } @else {
      You've read all your notifications
    }
  </div>
</mat-dialog-content>
